import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

import { getMenuItemNamesMediumColor } from 'styles/helpers/getThemeStyles';

export const MenuItemDescriptionTypography = styled(Typography)(
  ({ theme }) => ({
    color: getMenuItemNamesMediumColor(theme),
    lineHeight: 1.5
  })
);

export default MenuItemDescriptionTypography;
